var styles={fontElementMap:"_22Is7",orderedlist:"_1Y14M",bulletedlist:"IFTtn",listItem:"_30PEA"};export{styles as s};
//# sourceMappingURL=lists-69b3974c.js.map
